// Import polyfills first
import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeContactInfo } from './firebase/initContactInfo';

// Initialize contact information in Firestore
initializeContactInfo()
  .then(() => console.log("Contact information initialized"))
  .catch(error => console.error("Error initializing contact information:", error));

const container = document.getElementById('root');

// When the page was prerendered (scripts/prerender.js bakes static HTML into
// build/<route>/index.html), hydrate the existing markup instead of throwing it
// away. This preserves the server-painted content for a better LCP.
//
// We hydrate ONLY when the prerendered route matches the current URL. The
// homepage's build/index.html doubles as the SPA catch-all for non-prerendered
// routes (e.g. /cart, product detail pages); hydrating home markup there would
// cause a mismatch, so we fall back to a clean client render in that case.
const normPath = (p) => (p && p !== '/' && p.endsWith('/') ? p.slice(0, -1) : p);
const prerenderedPath = document.documentElement.getAttribute('data-prerendered-path');
const isPrerenderedMatch =
  document.documentElement.getAttribute('data-prerendered') === 'true' &&
  container.hasChildNodes() &&
  normPath(prerenderedPath) === normPath(window.location.pathname);

if (isPrerenderedMatch) {
  ReactDOM.hydrateRoot(container, <App />);
} else {
  const root = ReactDOM.createRoot(container);
  root.render(<App />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
